<div class="col-md-8 mr-auto ml-auto dropdown-container">
    <angular-multiselect [data]="itemList" [(ngModel)]="selectedItems" [settings]="settings" (onSelect)="onItemSelect($event)"
        (onDeSelect)="OnItemDeSelect($event)" (onSelectAll)="onSelectAll($event)" (onDeSelectAll)="onDeSelectAll($event)"></angular-multiselect>
</div>
<h4 class="example-title code-section">Code</h4>

<!--<p-tabView>
    <p-tabPanel header="{{tstitle}}">
       <ng2-gist [gistId]="tsgist"></ng2-gist>
    </p-tabPanel>
    <p-tabPanel header="{{htmltitle}}">
        <ng2-gist [gistId]="htmlgist"></ng2-gist>
    </p-tabPanel>
    <span *ngIf="cssgist">
        <p-tabPanel header="{{csstitle}}">
        <ng2-gist [gistId]="cssgist"></ng2-gist>
    </p-tabPanel>
    </span>
</p-tabView>
-->